import * as React from 'react'
import styles from './styles.module.css'

export function MainContentCentered({ children }: React.PropsWithChildren) {
  return (
    <div
      className={
        styles.mainContentCentered
      }
    >
      {children}
    </div>
  )
}

export function Content({ children }: React.PropsWithChildren) {
  return <div className={styles.content}>{children}</div>
}
